type Status =
	| 'PUBLISHED'
	| 'DRAFT'
	| 'INACTIVE'
	| 'CANCELED'
	| 'PENDING'
	| 'CONFIRMED'
	| 'DONE'
	| 'EXPIRED'
	| 'AWAITING_CONFIRMATION'
	| 'REFUNDED'
	| 'SUSPENDED'
	| 'ACTIVE'
	| 'AWAITING_CANCEL';

export const statusTranslate: Record<Status, string> = {
	PUBLISHED: 'Publicado',
	DRAFT: 'Rascunho',
	INACTIVE: 'Inativo',
	CANCELED: 'Cancelado',
	PENDING: 'Pendente',
	CONFIRMED: 'Confirmado',
	DONE: 'Completo',
	EXPIRED: 'Expirado',
	AWAITING_CONFIRMATION: 'Aguardando Confirmação',
	REFUNDED: 'Estornado',
	SUSPENDED: 'Suspenso',
	ACTIVE: 'Ativo',
	AWAITING_CANCEL: 'Aguardando Cancelamento',
};
